import { cn } from "@githits/shared";
import type { ReplayPhase } from "../data/types";

interface MockSearchBarProps {
  displayedQuery: string;
  cursorVisible: boolean;
  language: string | null;
  phase: ReplayPhase;
}

export default function MockSearchBar({
  displayedQuery,
  cursorVisible,
  language,
  phase,
}: MockSearchBarProps) {
  const isTyping = phase === "typing";
  const isSubmitting = phase === "submitting";

  return (
    <div
      className={cn(
        "ghw-relative ghw-flex ghw-items-center ghw-gap-3 ghw-rounded-[28px] ghw-border ghw-bg-secondary ghw-px-4 ghw-py-3",
        "ghw-transition-shadow ghw-duration-200",
        isTyping && "ghw-ring-2 ghw-ring-primary/40 ghw-border-primary/40",
        !isTyping && !isSubmitting && "ghw-border-border",
        isSubmitting && "animate-replay-bar-exit ghw-border-primary/40 ghw-ring-2 ghw-ring-primary/40"
      )}
    >
      {/* Language badge */}
      {language && (
        <span className="ghw-hidden sm:ghw-inline-flex ghw-items-center ghw-px-3 ghw-py-1 ghw-rounded-full ghw-bg-muted ghw-text-muted-foreground ghw-text-xs ghw-font-medium ghw-uppercase ghw-shrink-0">
          {language}
        </span>
      )}

      {/* Query text with cursor */}
      <div className="ghw-flex-1 ghw-min-w-0 ghw-text-sm sm:ghw-text-base ghw-text-foreground">
        {displayedQuery || (
          <span className="ghw-text-muted-foreground">Ask a coding question...</span>
        )}
        {cursorVisible && (
          <span
            className="ghw-inline-block ghw-w-[2px] ghw-h-[1.1em] ghw-bg-primary ghw-align-text-bottom ghw-ml-px ghw-animate-replay-caret-blink"
            aria-hidden="true"
          />
        )}
      </div>

      {/* Get Hits button */}
      <button
        type="button"
        disabled
        aria-label="Get Hits"
        className={cn(
          "ghw-shrink-0 ghw-px-5 ghw-py-2 ghw-rounded-full ghw-text-sm ghw-font-semibold ghw-text-white",
          "ghw-bg-[#FF4FAE]",
          isSubmitting
            ? "ghw-opacity-100 animate-replay-btn-pulse"
            : "ghw-opacity-70 ghw-cursor-default"
        )}
      >
        Get Hits
      </button>
    </div>
  );
}
